import AgentDiscoveryController from "./agent_discovery_controller"

export default class extends AgentDiscoveryController {
  // Backwards-compatible action name — views call saveIntegration, base uses save
  saveIntegration() {
    return this.save()
  }

  renderPreview(config) {
    if (!this.hasPreviewContentTarget) return

    let html = `
      <div class="space-y-3">
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Name</span>
          <p class="font-medium">${this.escapeHtml(config.name || 'Unnamed')}</p>
        </div>
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Base URL</span>
          <p class="text-sm font-mono">${this.escapeHtml(config.base_url || '')}</p>
        </div>
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Auth Type</span>
          <span class="badge badge-sm badge-info">${this.escapeHtml(config.auth_type || 'none')}</span>
        </div>
    `

    if (config.endpoints && config.endpoints.length > 0) {
      html += `
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Endpoints (${config.endpoints.length})</span>
          <div class="space-y-1 mt-1">
      `
      for (const ep of config.endpoints) {
        html += `
          <div class="text-sm border border-base-200 rounded p-2">
            <span class="badge badge-xs badge-primary">${this.escapeHtml(ep.method || 'GET')}</span>
            <code class="text-xs">${this.escapeHtml(ep.path || '')}</code>
            ${ep.record_count ? `<span class="text-xs text-base-content/60">(${ep.record_count} records)</span>` : ''}
          </div>
        `
      }
      html += '</div></div>'
    }

    if (config.sample_data && config.sample_data.length > 0) {
      html += `
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Sample Data (${config.sample_data.length} records)</span>
          <pre class="text-xs bg-base-200 rounded p-2 mt-1 overflow-x-auto max-h-48">${this.escapeHtml(JSON.stringify(config.sample_data[0], null, 2))}</pre>
        </div>
      `
    }

    if (config.description) {
      html += `
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Description</span>
          <p class="text-sm">${this.escapeHtml(config.description)}</p>
        </div>
      `
    }

    html += '</div>'
    this.previewContentTarget.innerHTML = html
  }
}
